import Config from './config'
import Phaser from 'phaser'
import Ship from '../ship/ship'
import {_setIsSelectingShips} from '../app/app'

const devSelectBox = () =>
    new Promise((resolve, reject) => {
        let shipY1 = 100
        let shipY2 = 100
        for (let i = 0; i < 8; i += 1) {
            new Ship({
                faction: Config.userFactionName,
                x: 50,
                y: shipY1,
            })
            shipY1 += 50
        }
        for (let i = 0; i < 8; i += 1) {
            new Ship({
                faction: Config.userFactionName,
                x: 100,
                y: shipY2,
            })
            shipY2 += 50
        }

        const graphics = Config.scene.add.graphics({
            lineStyle: {width: 2, color: 0xffff00},
        })
        let rect
        let draw = false
        let startX = 0
        let startY = 0

        Config.scene.input.on('pointerdown', function(pointer) {
            if (!Config.isSelectingShips) {
                return
            }

            startX = pointer.worldX
            startY = pointer.worldY
            draw = true
        })

        Config.scene.input.on('pointerup', function() {
            graphics.clear()
            // Config.isSelectingShips = false
            _setIsSelectingShips(false)
            draw = false
        })

        Config.scene.input.on('pointermove', function(pointer) {
            if (draw) {
                const endX = pointer.worldX - startX
                const endY = pointer.worldY - startY
                const width = Math.abs(endX)
                const height = Math.abs(endY)
                let x
                let y

                // Left
                if (endX < 0) {
                    // Top
                    x = pointer.worldX
                    y = pointer.worldY

                    // Bottom
                    if (endY > 0) {
                        y = startY
                    }
                }

                // Right
                if (endX > 0) {
                    // Bottom
                    x = startX
                    y = startY

                    // Top
                    if (endY < 0) {
                        y = pointer.worldY
                    }
                }

                rect = new Phaser.Geom.Rectangle(x, y, width, height)

                graphics.clear()
                graphics.strokeRectShape(rect)

                Object.keys(Config.ships).forEach((key) => {
                    const ship = Config.ships[key]

                    if (ship.faction === Config.enemyFactionName) {
                        return
                    }

                    const size = ship.formationRadius
                    const shipRect = new Phaser.Geom.Rectangle(
                        ship.x - size / 2,
                        ship.y - size / 2,
                        size,
                        size
                    )

                    // Draw debug graphics
                    // const graphics2 = Config.scene.add.graphics({
                    //     lineStyle: {width: 1, color: 0xffff00},
                    // })
                    // graphics2.clear()
                    // graphics2.strokeRectShape(shipRect)
                    // graphics2.setDepth(16)

                    const intersection = Phaser.Geom.Intersects.GetRectangleIntersection(
                        rect,
                        shipRect
                    )

                    if (intersection.width) {
                        Config.selectedShips[key] = ship.name
                        ship.selected = true
                    } else {
                        delete Config.selectedShips[key]
                        ship.selected = false
                    }
                })
            }
        })

        return resolve({planet: {x: 100, y: 100}})
    })

export default devSelectBox
